function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "225",
  height: "160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_281_15703)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.5 0v156.791a2.93 2.93 0 002.931 2.931H221.57a2.93 2.93 0 002.931-2.931V0H.5z",
  fill: "#F3F4F6"
}), /*#__PURE__*/React.createElement("rect", {
  x: "46.723",
  y: "35.714",
  width: "131.556",
  height: "89.286",
  rx: "4",
  fill: "#6310E5"
})), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1",
  width: "222",
  height: "157.722",
  rx: "3",
  stroke: "#DDE0E4",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_281_15703"
}, /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  width: "224",
  height: "159.722",
  rx: "4",
  fill: "#fff"
})))));